export const Bio = {
  name: "PAUL TENSINGH A",
  roles: [
    "Full Stack Developer",
    "Programmer",
    "Canva Design",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Paul-10-singh",
  resume:
    "https://drive.google.com/file/d/16L3kCKJ6Xgi6zz010GR0zdvZkTtrPhDE/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/paul-tensingh-a-8191b0349/",
  twitter: "https://app.netlify.com/user/settings#profile",
  insta: "https://www.instagram.com/paul._.2903?igsh=MWJpaHpjZ3F4dHd6bw==",
  facebook: "https://www.facebook.com/paul.tensingh.1/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Framework,Design",
    skills: [
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind Css",
        image:
          "https://w7.pngwing.com/pngs/771/978/png-transparent-tailwind-css-css-framework-customizable-low-level-tailwind-logo-3d-icon-thumbnail.png",
      },
      {
        name: "Canvas",
        image:
          "https://cdn3d.iconscout.com/3d/free/thumb/free-canva-3d-icon-download-in-png-blend-fbx-gltf-file-formats--logo-design-soft-tool-pack-logos-icons-7516879.png",
      },
      {
        name: "Figma",
        image:
          "https://w7.pngwing.com/pngs/54/524/png-transparent-figma-app-logo-tech-companies-thumbnail.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
   
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-2048x2026-lg873y7v.png",
      },
      {
        name: "MS Office",
        image:
          "https://png.pngtree.com/png-clipart/20190516/original/pngtree-microsoft-office-logo-icon-png-image_3588802.jpg",
      },
     
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEZROIw0J3blZHE3oPkupDdJMXX4YUCRVMGA&s",
    role: "FullStack Developer",
    company: "EDUREKA LEARNING CENTER, MADURAI.",
    desc: "Currently undergoing comprehensive training in full-stack web development, covering both front-end and back-end technologies. Learning modern web frameworks, databases, and development tools, including HTML, CSS, JavaScript, React, Node.js, Express, and MongoDB.Learning best practices in software development, version control (Git), and deployment.",
    skills: [
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "BOOTSTRAP",
      "TAILWIND",
      "REACT JS",
      "NODE JS",
      "MONGO DB",
    ],
  },
  {
    id: 0,
    img: "https://media.glassdoor.com/sqll/1027971/sion-semiconductors-pvt-squarelogo-1573131457399.png",
    role: "FPGA Designer INTERN",
    company: "Sion Semiconductors, BENGALURU.",
    desc: "Assisting in semiconductor design, testing, and validation processes. Gaining hands-on experience with VLSI design, circuit simulation, and hardware debugging. Conducting research and analysis to support innovation in semiconductor technology.",
    skills: [
      "vlsi design",
      "PCB circuit design",
      "Verilog",
      "circuit simulation",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://media.collegedekho.com/media/img/institute/logo/1445185115.jpg",
    school: "Nagasiva Polytechnic College",
    date: "Oct 2018 - Sep 2021",
    grade: "8.3 %",
    desc: "I am completed Diploma in Electronics and Communication Engineering in Nagasiva Polytechnic College ",
    degree: "Diploma in Electronics and Communication Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9My7bTibQTQR8yK7GSyVJlglHU_jnEwSo9g&s",
    school: "Velammal College Of Engineering And Technology, Madurai",
    date: "Apr 2021 - Apr 2024",
    grade: "7.3 CGPA",
    desc: "I completed my Degree in Velammal College Of Engineering And Technology at Madurai. While in college, I completed a variety of projects like DoS Attack Detection, Solar Automated Lawn Mower like etc. and i also Learn hardware knowledge (Arduino, Raspberry Pi), and software tools (MATLAB, Xilinx ) and i achived some CERTIFICATES (ML using Python) ",
    degree: "Bachelor of Engineering - B.E.Electronics and Communication Engineering",
  },
];

export const projects = [
  {
    id: 9,
    title: "Simple Paint Application",
    description:
      "A simple paint application is a basic program that allows users to create and edit a circle using a variety of mouse pointer. Typically, it includes essential features such as a drawing canvas, color selection, and tools like circle shapes, and an eraser. Users can choose different sizes, adjust size . These applications often allow for basic operations like undo/redo, and resizing the canvas. Despite its simplicity, a paint application can serve as a fun and intuitive tool for both beginner and casual artists to create simple illustrations or sketches. It often has a user-friendly interface, with minimal distractions, making it accessible for anyone who wants to quickly draw or experiment with digital art.",
    image:
      "https://github.com/Paul-10-singh/SIMPLE-PAINT-WEB-APPLICATION/blob/main/paint%20output.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "RESPONSIVE"
    ],
    github: "https://github.com/Paul-10-singh/SIMPLE-PAINT-WEB-APPLICATION",
    webapp: "https://simple-paint-website.netlify.app/",
  },


  {
    id: 0,
    title: "Data Visualization Dashboard",
    description:
      "Developed a full-stack web application that allows users to check the data or track selling product of fitness cheching etc...",
    image:
      "https://github.com/Paul-10-singh/data-dashboard/blob/main/Screenshot%202025-01-30%20163757.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "RESPONSIVE"
    ],
    github: "https://github.com/Paul-10-singh/data-dashboard",
    webapp: "https://data-dash-board.netlify.app/",
  },


  // {
  //   id: 1,
  //   title: "Crud Operation",
  //   description:
  //     "CRUD operations refer to the four basic functions used in database management systems and software development: Create, Read, Update, and Delete. These operations are fundamental for interacting with data in most applications, providing a structured way to manage and manipulate information. Create allows users to add new data, such as inserting a new record into a database. Read enables the retrieval of existing data, allowing users to view or query the information stored. Update involves modifying existing records, enabling users to change data as needed. Delete allows the removal of data that is no longer required. Together, these operations form the backbone of data management, ensuring users can easily store, access, modify, and remove data in a secure and efficient manner. CRUD operations are commonly used in web applications, APIs, and databases providing a simple yet powerful way to manage data throughout its lifecycle.,",
  //   image:
  //     "https://github.com/Paul-10-singh/CRUD/blob/master/Crud.png?raw=true",
  //   tags: [
  //     "HTML",
  //     "CSS",
  //     "JAVASCRIPT",
  //     "RESPONSIVE"
  //   ],
  //   github: "https://github.com/Paul-10-singh/CRUD",
  //   webapp: "https://crudoperations01.netlify.app/",
  // },


  {
    id: 2,
    title: "Hexagon",
    description:
      "A web project focused on traveling is a platform designed to help users explore and plan their travel experiences. It might feature sections like travel guides, destination suggestions, itineraries, and tips for different types of travelers. ",
    image:
      "https://github.com/Paul-10-singh/HEXAGON-SINGLE-WEBPAGE/blob/main/hexago%20output.png?raw=true",
    tags: [
        "HTML",
      "CSS",
      "Bootstrap",
      "RESPONSIVE"  
    ],
    github: "https://github.com/Paul-10-singh/HEXAGON-SINGLE-WEBPAGE",
    webapp: "https://clinquant-jalebi-42b4a6.netlify.app/",
  },


  {
    id: 3,
    title: "Style Mart",
    description:
      "A style mart is a place or platform where different styles, designs, or products are displayed for people to browse and buy. It can be related to fashion, home decor, or other areas where personal taste is important. In a style mart, you can find a variety of items from different designers or brands, helping you discover new trends or pick products that match your style. It makes it easier to explore and shop for items that fit your unique preferences, all in one place.",
    image:
      "https://github.com/Paul-10-singh/STYLE-MART-single-page-website-/blob/main/Screenshot%202025-01-30%20162540.png?raw=true",
    tags: ["HTML",
      "CSS",
      "Bootstrap",
      "RESPONSIVE" ],
    github: "https://github.com/Paul-10-singh/STYLE-MART-single-page-website-",
    webapp: "https://stylemart-singlepage-webpage.netlify.app/",
  },


  // {
  //   id: 10,
  //   title: "To-Do-List",
  //   description:
  //     "A to do list is a simple way to keep track of tasks you need to complete. It helps you stay organized by listing things to do and checking them off when finished. Whether for work or personal use, a to-do list helps you remember important tasks and stay focused. It can be written on paper or created digitally on a phone or computer.",
  //   image:
  //     "https://github.com/Paul-10-singh/TO-DO-LIST-/blob/main/To-doListproject.png?raw=true",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   // category: "android app",
  //   github: "https://github.com/Paul-10-singh/TO-DO-LIST-",
  //   webapp: "https://to-do-list-appli-cation.netlify.app/",
  // },
  
];

export const TimeLineData = [
  { year: 2023, text: "Started my journey" },
  { year: 2024, text: "learning a programs" },
  { year: 2025, text: "Shared my projects with the world" },
];
